module.exports = __webpack_public_path__ + "static/logos-06-6520508ddf3862d6df682852093afdbc.png";